import { render, staticRenderFns } from "./parentsInformation2.vue?vue&type=template&id=5eeaadb0&scoped=true&"
import script from "./parentsInformation2.vue?vue&type=script&lang=js&"
export * from "./parentsInformation2.vue?vue&type=script&lang=js&"
import style0 from "./parentsInformation2.vue?vue&type=style&index=0&id=5eeaadb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeaadb0",
  null
  
)

export default component.exports